import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { HttpService, ContextChange, AbstractWidgetComponent, WidgetStyle } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-visitor-export',
  templateUrl: './visitor-export.component.html',
  styleUrls: ['./visitor-export.component.scss']
})
export class VisitorExportComponent extends AbstractWidgetComponent implements OnInit {

  constructor(
    public translationService: TranslationService,
    private http: HttpService
  ) {
    super();
  }

  form: FormGroup;

  visitor = new Array<VisitEntry>();

  dataSource = new MatTableDataSource(this.visitor);

  columnsToDisplay = [
    'id',
    'reservation',
    'visitStatus',
    'arrival',
    'numberPlate',
    'reason',
    'notes',
    'company',
    'firstName',
    'name',
    'inRegularIntervals',
    'registrationCode',
    'groupMembers'
  ];

  ngOnInit() {

    this.form = new FormGroup({
      dateFrom: new FormControl(new Date(), [Validators.required]),
      dateUntil: new FormControl(new Date(), [Validators.required]),
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  updateList() {
    const selection = new VisitSelection(this.form.value.dateFrom, this.form.value.dateUntil, 200);
    this.dataSource.data = [];

    this.http.postWithContext<any>(`${environment.visitReportingEndpoint}/listexport-visitor`, selection)
      .subscribe(
        response => {
          this.visitor.splice(0, this.visitor.length);
          for (const p of response) {
            this.visitor.push(new VisitEntry(p));
          }
          this.dataSource.data = this.visitor;
        }
      );
  }

  createExcel() {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel-visitor');

    // keep focus in current window
    window.focus();

    const selection = new VisitSelection(this.form.value.dateFrom, this.form.value.dateUntil, 200);

    const url = `${environment.visitReportingEndpoint}/listexcel-visitor`;
    this.http.postWithArraybufferResponse<any>(url, selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public isUpdateListDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
  }

  public isCreateDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}

class VisitSelection {
  constructor(from: Date, until: Date, limit: number) {
    this.from = from;
    this.until = until;
    this.limit = limit;
  }
  from: Date;
  until: Date;
  limit: number;
}


export class VisitEntry {
  constructor(entry: any) {
    this.id = entry.id;
    this.reservation = entry.reservation;
    this.visitStatus = entry.personalVisitStatus;
    this.arrival = entry.start;
    this.numberPlate = entry.numberPlate;
    this.reason = entry.reason;
    this.notes = entry.notes;
    this.company = entry.company;
    this.firstname = entry.firstname;
    this.name = entry.name;
    this.inRegularIntervals = entry.inRegularIntervals;
    this.registrationCode = entry.registrationCode;
    this.groupMembers = entry.groupMembers;
  }

  id: number;
  reservation: string;
  visitStatus: string;
  arrival: string;
  numberPlate: string;
  reason: string;
  notes: string;
  company: string;
  firstname: string;
  name: string;
  inRegularIntervals: string;
  registrationCode: string;
  groupMembers: string;
}
